import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=089717a8&scoped=true&"
import script from "./BaseVideo.vue?vue&type=script&lang=js&"
export * from "./BaseVideo.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=089717a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089717a8",
  null
  
)

export default component.exports